import { Table, Button } from "react-bootstrap";
import { truncateText } from "../../utils";
import { useSelector } from "react-redux"
export default function PendingListView(props) {
    const {
        loading,
    } = useSelector((state) => state.clients)
    const {
        headers,
        data,
        handlePendingClientApprove,
    } = props;


    return (

        <>
            {Array.isArray(data) && data.length > 0 && (<Table
                hover
                responsive

            >
                <thead>
                    <tr>
                        {headers.map(header => {
                            return <th className="text-left" scope="col" key={header.id}>{header.name}</th>
                        })}
                        <th className="tecxt-center" scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(data) && data.map((ind_data) => {
                        return (
                            <tr key={ind_data.id}>
                                {Array.isArray(headers) && headers.map(header => {
                                    const rawValue = !!header.modifier ? header.modifier(ind_data[header.id]) : ind_data[header.id];
                                    const finalValue = `${rawValue ?? ''} ${header.suffix ?? ''}`;

                                    return (
                                        <td key={header.id} className="text-left">
                                            {truncateText(finalValue.trim(), 50)}
                                        </td>
                                    );
                                })}
                                <td>
                                    <>
                                        <Button
                                            variant="success"
                                            className="no-hover fw-bold mr-2"
                                            disabled={loading}
                                            onClick={() => handlePendingClientApprove(ind_data.id, true)}
                                            style={{ width: "100px" }}
                                        >
                                            {loading ? "Approving..." : "Approve"}
                                        </Button>
                                        <Button
                                            variant="danger"
                                            className="no-hover fw-bold"
                                            disabled={loading}
                                            onClick={() => handlePendingClientApprove(ind_data.id, false)}
                                            style={{ width: "100px" }}
                                        >
                                            {loading ? "Rejecting..." : "Reject"}
                                        </Button>
                                    </>
                                </td>
                            </tr>)
                    })}


                </tbody>
            </Table>)}
            {!data?.length && (<div> No Pending Clients Found </div>)}
        </>

    )
}